<template>
  <div id="roleManage">
    <el-form :inline="true" :model="searchForm">
      <el-form-item :label="level == 'A' ? '单位' :'部门'">
        <el-select style="width: 200px" size="mini" v-model="searchForm.companyId" clearable placeholder="请选择">
          <el-option
            v-for="item in companyList"
            :key="item.id"
            :label="level == 'A'?item.companyName:item.deptName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否生效">
        <el-select style="width: 100px" size="mini" v-model="searchForm.isWork" placeholder="请选择">
          <el-option
            v-for="item in workStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          size="mini"
          placeholder="搜索关键字"
          prefix-icon="el-icon-search"
          v-model="searchForm.keyWords">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="onSearch">查询</el-button>
        <el-button type="primary" size="mini" @click="onCreate">创建角色</el-button>
      </el-form-item>
    </el-form>
    <el-table
      max-height="500px"
      :data="tableData"
      style="width: 100%">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="NO"></el-table-column>
      <el-table-column prop="roleCn" label="角色名称"></el-table-column>
      <el-table-column prop="roleEn" label="英文名"></el-table-column>
      <el-table-column :prop="level == 'A' ? 'companyId':'deptName'" :label="level == 'A' ? '所属单位' : '所属部门'" :formatter="companyNameMatter"></el-table-column>
      <el-table-column prop="dataRange" label="数据范围" :formatter="dataRangeMatter"></el-table-column>
      <el-table-column prop="isWork" label="是否生效">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isWork"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="'1'"
            :inactive-value="'0'"
            @change="isWorkChange(scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="180">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="editRole(scope.row)"
            type="text"
            size="small">
            编辑
          </el-button>
          <el-button
            @click.native.prevent="deleteRole(scope.row)"
            type="text"
            size="small">
            删除
          </el-button>
          <el-button
            @click.native.prevent="settingModuleLimit(scope.row)"
            type="text"
            size="small">
            设置权限
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose">
      <el-form ref="roleForm" :model="roleForm" :rules="rules" label-width="120px" style="padding:0 40px 0 0">
        <el-form-item label="中文名称" prop="roleCn">
          <el-input v-model="roleForm.roleCn"></el-input>
        </el-form-item>
        <el-form-item label="英文名称" prop="roleEn">
          <el-input v-model="roleForm.roleEn"></el-input>
        </el-form-item>
        <el-form-item label="角色说明" prop="roleExplain">
          <el-input type="textarea" :rows="2" v-model="roleForm.roleExplain"></el-input>
        </el-form-item>
        <el-form-item :label="level == 'A' ? '关联单位' : '关联部门'" prop="companyId">
          <el-select style="width: 100%" :multiple="level == 'A' ?true:false" v-model="roleForm.companyId" placeholder="请选择">
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="level == 'A' ?item.companyName : item.deptName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据范围" prop="dataRange">
          <el-select style="width: 100%" v-model="roleForm.dataRange" placeholder="请选择">
            <el-option
              v-for="item in dataRangeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否生效" prop="isWork">
          <el-select style="width: 100%" v-model="roleForm.isWork" placeholder="请选择">
            <el-option
              v-for="item in workStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog
      title="权限设置"
      :visible.sync="dialogLimitVisible"
      :before-close="settingLimitClose"
      width="30%">
      <el-tree @check-change="nodeChange" :data="moduleList" :check-strictly="true" :props="defaultProps" ref="tree" node-key="id"  :default-checked-keys="checkedKeys" show-checkbox></el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="settingLimitClose">取 消</el-button>
        <el-button type="primary" @click="submitModuleLimit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import utils from '../utils/utils'
  export default {
    name: "role-manage",
    data(){
      return{
        workStatus:[{
          label:"是",
          value:"1"
        },{
          label:"否",
          value:"0"
        }],
        dataRangeList:[{
          label:"所有数据",
          value:1
        },{
          label:"公司及以下数据",
          value:2
        },{
          label:"部门及以下数据",
          value:3
        },{
          label:"仅本人数据",
          value:4
        },{
          label:"自定义数据",
          value:5
        }],
        searchForm:{
          companyId:null,
          isWork:"",
          keyWords:""
        },
        tableData:[],
        pageInfo:{
          currentPage:1,
          pageSize:20,
          total:0
        },
        level:null,
        companyList:[],
        roleForm:{
          roleCn:"",
          roleEn:"",
          companyId:null,
          dataRange:null,
          isWork:"",
          roleExplain:""
        },
        rules: {
          roleCn: [{required: true, message: '请输入角色中文名称', trigger: 'blur'},{ min: 1, max: 30, message: "长度在 1 到 30 个字符", trigger: "blur" }],
          //roleEn: [{required: true, message: '请输入角色英文名称', trigger: 'blur'},{ min: 1, max: 30, message: "长度在 1 到 30 个字符", trigger: "blur" }],
          //roleExplain: [{required: true, message: '请输入角色简介', trigger: 'blur'},{ min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }],
          companyId: [{required: true, message: '请选择关联单位', trigger: 'change'}],
          dataRange: [{required: true, message: '请选择数据范围', trigger: 'change'}],
          isWork: [{required: true, message: '请选择是否生效', trigger: 'change'}],
        },
        dialogTitle:"",
        dialogVisible:false,
        roleId:null,
        action:"",
        dialogLimitVisible:false,
        moduleList:[],
        defaultProps:{
          children: 'children',
          label: 'label'
        },
        checkedKeys:[]
      }
    },
    created(){
      this.level = this.$route.query.level;
      if(this.level == "A"){
        this.getCompanyAllA()
      }else{
        this.getDeptBAll()
      }
      this.getData()
    },
    methods:{
      getCompanyAllA(){
        utils.axiosMethods({
          method: "GET",
          url: "/api/platform/queryCompanyAllA",
          callback:(res => {
            this.companyList = res.data.list;
          })
        })
      },
      nodeChange(data,value,child){
        if(data.children && data.children.length>0){
          for(let i in data.children){
            this.$refs.tree.setChecked(data.children[i].id,value)
          }
        }
        console.log(data,value,child)
      },
      getDeptBAll(){
        utils.axiosMethods({
          method: "GET",
          url: "/api/accountManage/queryDeptBAll",
          callback:(res => {
            this.companyList = res.data.list;
          })
        })
      },
      getData(){
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0)'
        });
        let success = (response) => {
          loading.close();
          if(response.data.code === 0){
            this.pageInfo.total = response.data.total;
            this.tableData = response.data.list;
          }
        }
        var data = {
            isWork:this.searchForm.isWork,
            companyId:this.searchForm.companyId,
            keyWords:this.searchForm.keyWords
          }
        if(this.level=="B"){
          data.level = "0";
        }
        if(this.level=="C"){
          data.level = "1";
        }
        utils.axiosMethods({
          method:"POST",
          url:this.level == "A" ? "/api/platform/queryRoleA":"/api/accountManage/queryRoleB",
          params:{
            currentPage:this.pageInfo.currentPage,
            pageSize:this.pageInfo.pageSize
          },
          data:data,
          callback:success,
          catch:(err => {
            loading.close()
          })
        })
      },
      onSearch(){
        this.getData()
      },
      isWorkChange(row){
        let isWork = row.isWork == '1' ? '0':'1';
        utils.axiosMethods({
          method: "GET",
          url: this.level == "A"?"/api/platform/changeWorkStatus":"/api/accountManage/changeWorkStatus",
          params:{
            id:row.id,
            isWork:isWork
          },
          callback:(res => {
            this.$message.success("操作成功");
            this.getData();
          })
        })
      },
      deleteRole(row){
        utils.axiosMethods({
          method: "GET",
          url: this.level == "A"?"/api/platform/deleteRoleA":"/api/accountManage/deleteRoleB",
          params: {
            id: row.id,
          },
          callback: (res => {
            this.$message.success("删除成功");
            this.getData();
          })
        })
      },
      onCreate(){
        this.dialogTitle = "创建角色"
        this.dialogVisible = true
        this.action = "add"
      },
      editRole(row){
        this.dialogTitle = "编辑角色"
        this.dialogVisible = true
        this.action = "update"
        this.roleForm = {
          roleCn:row.roleCn,
          roleEn:row.roleEn,
          companyId:this.level == "A" ? row.companyId.split(',').map(id => id = parseInt(id)) : row.deptId,
          dataRange:row.dataRange,
          isWork:row.isWork,
          roleExplain:row.roleExplain
        }
        this.roleId = row.id
      },
      handleClose(){
        this.dialogVisible = false;
        this.roleForm = {
          roleCn:"",
          roleEn:"",
          companyId:null,
          dataRange:null,
          isWork:"",
          roleExplain:""
        }
        this.roleId = null;
      },
      submitForm(){
        //验证表单
        this.$refs["roleForm"].validate((valid) => {
          if(valid){
            let url,formData;
            formData = {
              roleCn:this.roleForm.roleCn,
              roleEn:this.roleForm.roleEn,
              dataRange:this.roleForm.dataRange,
              isWork:this.roleForm.isWork,
              roleExplain:this.roleForm.roleExplain
            }
            if(this.level == "A"){
              formData.companyId = this.roleForm.companyId.join(',')
            }else{
              formData.deptId = this.roleForm.companyId
            }
            if(this.action == "add"){
              if(this.level == "A"){
                url = "/api/platform/insertRoleA"
              }else{
                url = "/api/accountManage/insertRoleB"
              }
            }else{
              if(this.level == "A"){
                url = "/api/platform/updateRoleA"
              }else{
                url = "/api/accountManage/updateRoleB"
              }
              formData.id = this.roleId
            }
            utils.axiosMethods({
              method: "POST",
              url: url,
              data:formData,
              callback:(res => {
                this.dialogVisible = false;
                if(this.action == "add"){
                  this.$message.success("创建成功");
                }else{
                  this.$message.success("修改成功");
                }
                this.getData();
              })
            })
          }
        })
      },
      companyNameMatter(row, column, cellValue, index){
        let companyIds = this.level == "A" ? cellValue.split(',') : cellValue;
        let companyNames = [];
        if(this.level == "A") {
          companyIds.map(id => {
            const _company = this.companyList.filter(company => company.id == id);
            if(_company && _company.length>0){
              companyNames.push(_company[0].companyName)
            }
          })
        }else{
          // const _company =this.companyList.filter(company => company.id == companyIds);
          //   if(_company && _company.length>0){
          //     companyNames.push(_company[0].companyName)
          //   }
          companyNames.push(cellValue)
        }
        return companyNames.join(";")
      },
      dataRangeMatter(row, column, cellValue, index){
        return this.dataRangeList.filter(dataRange => dataRange.value == cellValue)[0].label;
      },
      //每页展示数据条数改变
      handleSizeChange(val){
        this.pageInfo.pageSize = val;
        this.getData();
      },
      //页码改变
      handleCurrentChange(val){
        this.pageInfo.currentPage = val;
        this.getData();
      },
      settingModuleLimit(row){
        this.roleId = row.id
        this.getModuleList(row.id)
      },
      settingLimitClose(){
        this.roleId = null
        this.dialogLimitVisible = false
      },
      getModuleList(roleId){
        let url;
        if(this.level == "A"){
          url = "/api/platform/getSettingMenuList"
        }else{
          url = "/api/accountManage/getSettingMenuList"
        }
        utils.axiosMethods({
          method: "GET",
          url: url,
          params:{
            roleId:roleId
          },
          callback:(res => {
            this.dialogLimitVisible = true;
            this.moduleList = res.data.list;
            this.checkedKeys = res.data.obj.selectedKeys;
          })
        })
      },
      submitModuleLimit(){
        let selectNodes = this.$refs.tree.getHalfCheckedNodes().concat(this.$refs.tree.getCheckedNodes());
        let selectModuleId = [];
        selectNodes.map(node => {
          selectModuleId.push(node.id)
        });
        let url;
        if(this.level == "A"){
          url = "/api/platform/setSettingMenuList"
        }else{
          url = "/api/accountManage/setSettingMenuList"
        }
        utils.axiosMethods({
          method: "GET",
          url: url,
          params:{
            moduleIds:selectModuleId.join(","),
            roleId:this.roleId
          },
          callback:(res => {
            this.$message.success(res.data.msg)
            this.settingLimitClose()
          })
        })
      }
    }
  }
</script>

<style scoped lang="less">
  #roleManage{
    .block{
     float: right;
     margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/roleManage.vue